import * as React from "react";

import { useAffinityFormReturn } from "../useAffinityFormControls";

export const AffinityFormContext = React.createContext<Maybe<useAffinityFormReturn>>(null);
